import * as Yup from 'yup'
import EmailSchema from './EmailSchema'

export const VerifyCreateAccountSchema = EmailSchema.shape({
  dob: Yup.string().required('Date of birth is required'),
})

export type VerifyCreateAccountValues = Yup.InferType<typeof VerifyCreateAccountSchema>
